import { useState, useEffect } from "react";
import { useAuth } from "../../login/AuthProvider";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { backend } from "../../../components/apipath";

function ResendArea({ email }) {
    const [cooldown, setCooldown] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (cooldown <= 0) return;
        const t = setInterval(() => setCooldown((s) => s - 1), 1000);
        return () => clearInterval(t);
    }, [cooldown]);

    const resend = async () => {
        if (!email || loading || cooldown > 0) return;
        setLoading(true);
        try {
        const res = await fetch(`${backend}join/resend`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ account: email }),
        });
        const data = await res.json();
        await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            color: "#224040",
            text: data.message || "已重寄驗證信",
        });

        // 從訊息抓冷卻秒數（若沒有就用 60）
        const m = (data.message || "").match(/\d+/);
        const sec = data.code === "429" && m ? Number(m[0]) : 60;
        setCooldown(sec);
        } catch (e) {
        await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            title: "糟糕！",
            color: "#224040",
            text: "重寄失敗，請稍後再試",
        });
        } finally {
        setLoading(false);
        }
    };

    return (
        <div className="mt-3">
        <small>尚未完成 Email 驗證？</small>
        <button
            type="button"
            className="btn btn-sm btn-dark ms-2"
            disabled={loading || cooldown > 0}
            onClick={resend}
        >
            {loading ? "寄送中…" : cooldown > 0 ? `請等待 ${cooldown}s` : "重寄驗證信"}
        </button>
        </div>
    );
    }

    function Login() {
    const [myform, setMyform] = useState({ account: "", password: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showResend, setShowResend] = useState(false);
    const [pendingEmail, setPendingEmail] = useState("");

    const changeFields = (event) => {
        const { id, value } = event.target;
        setMyform((s) => ({ ...s, [id]: value }));
    };

    const { setAuth } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
        const r = await fetch(`${backend}join/login`, {
            method: "POST",
            body: JSON.stringify(myform),
            headers: { "Content-Type": "application/json" },
            credentials: "include",
        });
        const result = await r.json();

        if (result.success) {
            localStorage.setItem("auth", JSON.stringify(result.data));
            await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            color: "#224040",
            text: "登入成功",
            });
            setAuth({ ...result.data, authorized: true });
            const searchParams = new URLSearchParams(window.location.search);
            const redirect = searchParams.get("redirect");
            navigate(redirect || "/member");
        } else if (result.code === 401) {
            await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            title: "糟糕！",
            color: "#224040",
            text: "查無此帳號，請先申請會員",
            });
        } else if (result.code === 402) {
            await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            title: "糟糕！",
            color: "#224040",
            text: "密碼錯誤，請填寫正確密碼",
            });
        } else if (result.code === 403) {
            await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            title: "帳號已被停用",
            color: "#224040",
            text: "請聯絡客服或管理員啟用帳號",
            });
        } else if (result.code === 405) {
            // 未驗證：顯示重寄按鈕
            setShowResend(true);
            setPendingEmail(myform.account);
            await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            color: "#224040",
            text: "請先完成 Email 驗證。若沒收到信，請點「重寄驗證信」。",
            });
        } else {
            await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            title: "登入失敗",
            color: "#224040",
            text: result.error || "請稍後再試，或聯絡客服",
            });
        }
        } catch (err) {
        console.error(err);
        await Swal.fire({
            imageUrl: "/member_img/logo.svg",
            confirmButtonColor: "#224040",
            title: "伺服器錯誤",
            color: "#224040",
            text: "請稍後再試",
        });
        } finally {
        setIsSubmitting(false);
        }
    };

    return (
        <>
        <form
            className="forms_form"
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
            // 防止 Enter 在 loading 時重複送出
            if (isSubmitting && e.key === "Enter") e.preventDefault();
            }}
        >
            <fieldset className="forms_fieldset">
            <div className="forms_field">
                <input
                type="email"
                placeholder="Email"
                className="forms_field-input"
                id="account"
                value={myform.account}
                onChange={changeFields}
                required
                autoFocus
                />
            </div>
            <div className="forms_field">
                <input
                type="password"
                placeholder="Password"
                id="password"
                name="password"
                className="forms_field-input"
                value={myform.password}
                onChange={changeFields}
                required
                />
            </div>
            </fieldset>

            {showResend && <ResendArea email={pendingEmail} />}

            <div className="forms_buttons">
            <button
                type="button"
                className="forms_buttons-forgot"
                onClick={() => {
                Swal.fire({
                    title: "忘記密碼？",
                    text: "請輸入註冊時的 Email",
                    input: "email",
                    inputPlaceholder: "email@example.com",
                    confirmButtonText: "送出",
                    showCancelButton: true,
                    cancelButtonText: "取消",
                    confirmButtonColor: "#224040",
                    color: "#224040",
                    imageUrl: "/member_img/logo.svg",
                }).then(async (result) => {
                    if (result.isConfirmed && result.value) {
                    try {
                        const res = await fetch(`${backend}join/forgot-password`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ email: result.value }),
                        });
                        const data = await res.json();
                        await Swal.fire({
                        title: data.code === "200" ? "請查收 Email" : "錯誤",
                        text:
                            data.message ||
                            (data.code === "200" ? "密碼重設說明已寄出" : "找不到該帳號"),
                        imageUrl: "/member_img/logo.svg",
                        confirmButtonColor: "#224040",
                        color: "#224040",
                        });
                    } catch (err) {
                        console.error("忘記密碼錯誤", err);
                        await Swal.fire({
                        title: "伺服器錯誤",
                        text: "請稍後再試",
                        imageUrl: "/member_img/logo.svg",
                        confirmButtonColor: "#224040",
                        color: "#224040",
                        });
                    }
                    }
                });
                }}
            >
                忘記密碼?
            </button>

            <input
                type="submit"
                value={isSubmitting ? "登入中…" : "登入"}
                className="forms_buttons-action"
                disabled={isSubmitting}
            />
            </div>
        </form>
        </>
    );
    }

    export default Login;
